import axios from 'axios';
export const apiAutocomplete = options => {
  return axios.post('/api/locator/autocomplete', options);
};